<template>
  <!--
  <div class="homeContainer">

    <h2 class="font-weight-bold mb-4 centers">Le Refuge</h2>


    <div class="row">
      <div class="col-lg-12 ">
        <div class="alignInformation">
          <h2 class="font-weight-bold mb-4 centers2">Nos informations</h2>
          <p v-html="formattedHorraire"></p>

        </div>

      </div>

    </div>
    <br>
    <br>
    <br>


  </div>

  
  
  -->
 <div class="hero-section">
       <div class="hero-text">
          <!-- Texte supprimé pour correspondre à l'image -->
          Association Alma
       </div>
    </div>
 <div class="container-75 value-boxes">
  <div class="row d-none d-md-flex justify-content-center ">
    <!-- Grille classique pour desktop -->
    <div class="col-md-3 " v-for="(item, i) in items" :key="i" @click="navigate(item)" style="cursor: pointer;">
      <div class="value-box hovereffect">
        <div class="value-icon"><i :class="item.icon"></i></div>
        <p><b>{{ item.title }}</b></p>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>

  <!-- Slider horizontal pour mobile -->
<div class="d-flex d-md-none overflow-auto flex-nowrap px-2 gap-3">
  <div
    class="slider-box flex-shrink-0"
    v-for="(item, i) in items"
    :key="i"
    @click="navigate(item)"
    style="cursor: pointer;"
  >
    <div class="value-box text-center">
      <div class="value-icon"><i :class="item.icon"></i></div>
      <p><b>{{ item.title }}</b></p>
      <p>{{ item.text }}</p>
    </div>
  </div>
</div>
</div>

  

  
  <div class="seperation downside"></div>

    <div class="container-75 margin20">
       <div class="text-center mb-4 ">
          <div class="row">
             <div class="col-lg-3">
             </div>
             <div class="col-lg-6">
                <div class="pate">
                   <i class="fas fa-paw coologreen"></i>
                </div>
                 <h2 class="font-weight-bold mb-4 centers">Les derniers arrivés</h2>
                <div class="red_button shop_now_button buttonadaptatif bluenow "> <router-link style="color:white !important"
                to="/animaux">Voir tous
                nos animaux</router-link></div>
             </div>
             <div class="col-lg-3">
             </div>
          </div>
       </div>
    </div>

  <div class="container">

  </div>

  <homeData :chiens="chiens" />
  <br><br>
  <homeData :chiens="chats" />



  <div id="actuID" class="seperation" ></div>

  <div class="homeContainerRefuge" >
    <h2    class="font-weight-bold mb-4 centers">Les Derniers Evénements</h2>

    <table class="table" id="contact" >
      <tbody>
        <tr v-for="newss in  news " v-bind:key="newss.id">
          <td>
            <img :src="'https://admin.asso-refuge.fr/images/' + newss.image" :class="'tailleimglogo'" style="" />
          </td>
          <td class='titleRefuge colorblue'>
            <router-link :to="'/publication/' + newss.id">
              {{ newss.nom }}
            </router-link>
          </td>
          <td class='titleRefuge notmobile'>{{ newss.resume }}</td>
          <td class='titleRefuge'>
            <router-link :to="'/publication/' + newss.id">
              <i class="fas fa-plus-circle"></i>
            </router-link>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
  <div v-if="idSite === 16" id="refuge" class="main_slider testheaderpicture"
    style="background-image:url('../assets/images/transiby.png'); height: 450px;">
    <div class="container fill_height">
      <div class="row align-items-center fill_height">
        <div class="col">
          <div class="main_slider_content">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div  class="seperation" ></div>


  <div class="homeContainerRefuge" id="refuge">

    <div class="container">
      <h3 class="font-weight-bold mb-4 centers" id="top">Les Informations </h3>
      <div class="mid">
      </div>
    </div>



    <div class="container">
      <div class="row">
        <div class="col-lg-7 col-12">

          <div class="card" style="margin-bottom: 0px;border-radius: 10px;">
            <div class="container " style="margin-top: 20px;">
              <h4 class="titleblue titlecontainershop" style="text-align: left;"><b>{{ informations.title
                  }}:</b></h4>
              <div v-html="formattedPresentation" class=""></div>

            </div>
          </div>

 


        </div>
        <div class="col-lg-5">
          <div class="card" style="margin-bottom: 0px;border-radius: 10px;">
            <div class="container " style="margin-top: 20px;">
              <h4 class="titleblue titlecontainershop" style="text-align: left;"><b>Email:</b></h4>
              <p v-html="formattedEmail" class=""></p>
            </div>
          </div>
          <div class="card" style="margin-bottom: 0px;border-radius: 10px;">
            <div class="container " style="margin-top: 20px;">
              <h4 class="titleblue titlecontainershop" style="text-align: left;"><b>Adresse:</b></h4>
              <p v-html="formattedAdresse" class=""></p>
            </div>
          </div>
          <div class="card" style="margin-bottom: 0px;border-radius: 10px;">
            <div class="container " style="margin-top: 20px;">
              <h4 class="titleblue titlecontainershop" style="text-align: left;"><b>Telephone:</b></h4>
              <p v-html="formattedPhone" class=""></p>
            </div>
          </div>
          <div class="card" style="margin-bottom: 0px;border-radius: 10px;">
            <div class="container " style="margin-top: 20px;">
              <h4 class="titleblue titlecontainershop" style="text-align: left;"><b>Horaire:</b></h4>
              <p v-html="formattedHorraire" class=""></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>

  </div>
</template>

<script setup>
import homeData from '../components/homeData.vue'
</script>
<script>
export default {
  data() {
    return {
      informations: [],
      news: [],
      animaux: [],
      chats: [],
      chiens: [],
        items: [
      {
        icon: 'fas fa-paw coologreen',
        title: 'Information',
        text: 'Retrouvez les informations du refuge',
        route: { path: '/', hash: '#refuge' },
      },
      {
        icon: 'fas fa-chalkboard-teacher coolored',
        title: 'Adhérer',
        text: 'Les adhésions sont indispensables pour aider le refuge',
        route: { path: '/besoins' },
      },
      {
        icon: 'fas fa-heart coologreen',
        title: 'Faire un don',
        text: 'Merci pour votre générosité',
        route: { path: '/besoins' },
      },
    ]
    };
  },
  
  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(response => response.json())
      .then(data => {
        // Vérifiez que data[0] existe et a un champ horraire
        if (data.length > 0) {
          this.informations = data[0];
          console.log(data[0]);
        } else {
          console.error('Les données reçues sont incorrectes ou vides.');
        }
      })
      .catch(error => {
        console.error('Il y a eu un problème avec votre requête :', error.message);
      });

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        this.news = data;
      })
      .catch(error => {
        console.error('Il y a eu un problème avec votre requête :', error.message);
      });

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        // Combine all animals into a single array
        this.animaux = data
        this.chats = data.filter(animal => animal.type === "chat");
        this.chiens = data.filter(animal => animal.type === "chien");
      })
      .catch(error => {
        console.error('Il y a eu un problème avec votre requête :', error.message);
      });
  },


  computed: {
    formattedHorraire() {
      if (this.informations && this.informations.horraire) {
        // Remplacer \r\n par <br>
        
        return this.informations.horraire.replace(/\r\n/g, '<br>');
      }
      return '';
    },
    formattedEmail() {
      if (this.informations && this.informations.email) {
        // Remplacer \r\n par <br>
        return this.informations.email.replace(/\r\n/g, '<br>');
      }
      return '';
    },
    formattedAdresse() {
      if (this.informations && this.informations.address) {
        // Remplacer \r\n par <br>
        return this.informations.address.replace(/\r\n/g, '<br>');
      }
      return '';
    },
formattedPresentation() {
  if (this.informations && this.informations.presentation) {
    let decoded = this.decodeHtml(this.informations.presentation);

    // Supprimer les br &nbsp;
    decoded = decoded.replace(/<br\s*\/?>/gi, '')
                     .replace(/&nbsp;/gi, ' ')
                     .trim();

    // Si ça contient un iframe mal formé → on reconstruit
    const iframeMatch = decoded.match(/src="([^"]+)"[^>]*title="([^"]*)"/i);

    if (iframeMatch) {
      const src = iframeMatch[1];
      const title = iframeMatch[2] || 'Video';

      return `
        <div class="ratio ratio-16x9">
          <iframe src="${src}" title="${title}" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen>
          </iframe>
        </div>
      `;
    }

    // Sinon, gérer le texte classique
    return decoded.replace(/\r?\n/g, '<br>');
  }
  return '';
},


    formattedPhone() {
      if (this.informations && this.informations.phone) {
        // Remplacer \r\n par <br>
        return this.informations.phone.replace(/\r\n/g, '<br>');
      }
      return '';
    }
  },

  methods: {
  navigate(item) {
    this.$router.push(item.route);
  },
    decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
}
}
</script>